import * as yup from "yup";
import { createRequiredTrimmedString, createRichTextRequiredSchema } from "./schemaUtils";

const emptyDateToNull = (value, originalValue) =>
  originalValue === "" || originalValue == null ? null : value;

export const createMilestone = yup
  .object({
    epic_name: createRequiredTrimmedString("Name is required").max(
      30,
      "Maximum 30 characters allowed"
    ),
    description: createRichTextRequiredSchema(
      "Description is required",
      "Description cannot be empty"
    ),
    start_date: yup
      .date()
      .transform(emptyDateToNull)
      .nullable()
      .typeError("Please enter a valid start date")
      .test(
        "start-before-target",
        "Start date can't be after target date",
        function (value) {
          const { target_release_date: targetReleaseDate } = this.parent;

          if (!value || !targetReleaseDate) {
            return true;
          }

          return value <= targetReleaseDate;
        }
      ),
    target_release_date: yup
      .date()
      .transform(emptyDateToNull)
      .nullable()
      .typeError("Please enter a valid target date")
      .test(
        "target-after-start",
        "End date can't be before start date",
        function (value) {
          const { start_date: startDate } = this.parent;

          if (!value || !startDate) {
            return true;
          }

          return value >= startDate;
        }
      ),
  })
  .required();
